import { render } from "./LoginHome.vue?vue&type=template&id=b8595f50&scoped=true"
import script from "./LoginHome.vue?vue&type=script&lang=js"
export * from "./LoginHome.vue?vue&type=script&lang=js"

import "./LoginHome.vue?vue&type=style&index=0&id=b8595f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8595f50"]])

export default __exports__